import React from "react";
import { Link, Redirect } from "react-router-dom";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import Form from "../../components/common/form";
import http from "../../services/httpService";
import auth from "../../services/authService";
import BrandingLogo from "../../components/common/BrandingLogo";
import BrandingAppTitle from "../../components/common/BrandingAppTitle";
import { appVersion } from "../../config";

class ForgotPasswordForm extends Form {
  state = {
    data: {
      email: "",
    },
    errors: {},
  };

  schema = {
    email: Joi.string().required().email().label("Email"),
  };

  doSubmit = async () => {
    try {
      const email = this.state.data.email;
      const { data } = await http.post(`/client/forgot-password`, { email });
      toast.success(data?.message || "If the account exists, a password reset email has been sent.");
    } catch (ex) {
      const errorMessage =
        (ex.response &&
          (typeof ex.response.data === "string"
            ? ex.response.data
            : ex.response.data?.error)) ||
        ex.message ||
        "Request failed.";
      toast.error(errorMessage);
    }
  };

  render() {
    if (auth.getCurrentUser()) return <Redirect to="/home" />;

    return (
      <React.Fragment>
        <div className="d-flex flex-column justify-content-center align-items-center min-vh-100">
          <form
            className="form-signin border border-light rounded shadow mb-3"
            onSubmit={this.handleSubmit}
          >
            <BrandingLogo className="mx-auto d-block mb-2" maxHeight="45px" />
            <p className="text-muted text-center small m-3">Client Portal</p>
            <hr className="mb-5" />

            {this.renderFloatingInput("email", "Email", "email", "email")}

            <div className="d-flex justify-content-between align-items-center mt-3">
              <Link className="small text-muted" to="/login">Back to login</Link>
            </div>

            {this.renderButton("Send reset link", <i className="fa fa-envelope" />, "block")}
          </form>
          <p className="text-muted text-center small">
            © {new Date().getFullYear()} <BrandingAppTitle /> {appVersion && <span>v{appVersion}</span>}
          </p>
        </div>
      </React.Fragment>
    );
  }
}

export default ForgotPasswordForm;
